<template>
  <div>
    <span
      v-if="data.column.field === 'name'"
    >
      <b-button
        v-b-modal.modal-add-edit-ad-formats
        variant="link"
        size="sm"
        @click="editAdFormatsModel(data.row)"
      >
        {{ data.formattedRow.name }}
      </b-button>
    </span>

    <span v-else-if="data.column.field === 'lastModified'">
      {{ new Date(Date.parse(data.row.lastModified)).toLocaleString() }}
    </span>

    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import store from '@/store'

export default {
  props: {
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const editAdFormatsModel = adFormat => store.commit('SET_AD_FORMAT_MODEL', adFormat)
    return { editAdFormatsModel }
  },
}
</script>
